import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { VideoContainerService } from '@app/shared/components/video-container/video-container.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PopoverPosition } from './video-popover.directive';

@Component({
  selector: 'rk-video-popover',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  templateUrl: './video-popover.component.html',
  styleUrl: './video-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoPopoverComponent {
  title = '';
  description = '';
  src = '';
  thumb: '';
  knowledgeBaseUrl = '';
  style: object = {};
  position: PopoverPosition = 'top';
  destroy = false;

  constructor(
    private readonly videoContainer: VideoContainerService,
    private readonly translate: TranslateService,
  ) {}

  setProperties(props: object) {
    Object.assign(this, props);
  }
  destroyPopover() {
    this.destroy = true;
  }

  playVideo() {
    this.videoContainer.playVideo(this.translate.instant(this.src));
  }
}
